import { useEffect, useState } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import NotFoundPage from '@/pages/NotFoundPage';
import legacyMap from '../../scripts/legacy-redirects.json';

/**
 * LegacyRedirect — safety net for old WordPress URLs.
 * The PRIMARY fix is the nginx 301 map (deploy/nginx-legacy-redirects.conf,
 * generated by scripts/gen-nginx-redirects.mjs from the same JSON). This
 * component covers the preview host and any request that reaches the SPA.
 * Renders a real 404-style page (not a blank screen) when nothing matches.
 */
export default function LegacyRedirect() {
  const location = useLocation();
  const [target, setTarget] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let p = location.pathname.toLowerCase();
    if (p.length > 1 && !p.endsWith('/')) {
      // Try both with and without trailing slash
    }
    const withSlash = p.endsWith('/') ? p : p + '/';
    const withoutSlash = p.endsWith('/') && p.length > 1 ? p.slice(0, -1) : p;

    const exact = (legacyMap.exact as Record<string, string>);
    let hit = exact[p] ?? exact[withSlash] ?? exact[withoutSlash];

    if (!hit) {
      for (const rule of legacyMap.patterns) {
        const re = new RegExp(rule.match, 'i');
        if (re.test(withSlash) || re.test(withoutSlash)) {
          hit = rule.to.replace(/\$(\d)/g, (_, n) => {
            const m = withSlash.match(re) || withoutSlash.match(re);
            return m ? (m[Number(n)] ?? '') : '';
          });
          break;
        }
      }
    }
    setTarget(hit ?? null);
  }, [location.pathname]);

  if (target === undefined) return null;
  if (target) {
    if (target.startsWith('http')) {
      window.location.replace(target);
      return null;
    }
    return <Navigate to={target} replace />;
  }
  return <NotFoundPage />;
}
